const local = {
    API: 'http://local.bpmsupreme.com:3002',
    LATINO_API: 'http://local.bpmsupreme.com:8082',
    CREATE_API: 'http://local.bpmsupreme.com:3003',
    DOWNLOAD_API_URL: 'https://api.download.bpmsupreme.com/v1',
    STORAGE_V: '2',
    POOL_URL: 'http://local.bpmsupreme.com:3001'
};
const prod = {
    API: 'https://admin-api.bpmsupreme.com',
    LATINO_API: 'https://admin-api.latino.bpmsupreme.com',
    CREATE_API: 'https://admin-api.create.bpmsupreme.com',
    DOWNLOAD_API_URL: 'https://api.download.bpmsupreme.com/v1',
    STORAGE_V: '2',
    POOL_URL: 'https://app.bpmsupreme.com'
};

const config = process.env.REACT_APP_STAGE === 'local' ? prod : prod
export let Environment = config;
(global as any).Environment = config


// WEBPACK FOOTER //
// ./src/env.ts